module.exports = __webpack_public_path__ + "static/img/6.5d77f7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/6.png
// module id = 4w1s
// module chunks = 0